import Api from '@/axios'

export default {
  getAllCouponsLimit () {
    return Api().get('coupons?limit=1000')
  },
  getCopoun (id) {
    return Api().get(`coupons/${id}`)
  },
  addCoupon (payload) {
    return Api().post('coupons', payload)
  },
  editCoupon (id, payload) {
    return Api().post(`coupons/${id}`, payload)
  }
}
